export default "__VITE_ASSET__Bn_LQnaV__"